/**
 * The shell's own numbers — one rhythm, one file.
 *
 * Carried across from `preview/design-toggle-all`'s layout experiment, where
 * the captain settled them by eye over several rounds. The two that matter:
 *
 *  • `SHELL_GUTTER` is the ONLY spacing the shell is built on. The sidebar
 *    column and the inset panel each keep exactly this distance to the window
 *    and to each other, so neither can drift from the other — that drift is
 *    what the captain caught on the preview branch.
 *  • `PANEL_HEADER_HEIGHT` is the panel's own header row, the one that now
 *    carries the collapse control and the breadcrumbs. It is a `h-12` in the
 *    markup; the number exists because one CSS rule needs a length (see
 *    `ShellInset.tsx`), and `__tests__/shell-geometry.test.ts` holds the two
 *    in step.
 *
 * The sidebar ROW's geometry is deliberately NOT here: it belongs to the nav,
 * and the nav owns it — `SIDEBAR_ROW_METRICS` in `src/antd/Menu.shadcn.tsx`.
 */
export const SHELL_GUTTER = 12

/** `h-12` on `[data-slot='shell-panel-header']`. */
export const PANEL_HEADER_HEIGHT = 48
